import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { SemiMonthlySummaryDashboard } from '../ui/components';
import useGetPaymentClouderServices from './useGetPaymentClouderServices';

import { CLOUDER_SERVICES } from '@wareclouds/frontend-common/b2c';

export default function useGetServiceTabItems({ period }) {
  const { t } = useTranslation(['description']);
  const [activeTab, setActiveTab] = useState(null);

  const {
    data: paymentClouderServices,
    isPending: isLoadingPaymentClouderServices,
  } = useGetPaymentClouderServices();

  const tabs = paymentClouderServices?.map((service, index) => {
    return {
      id: service,
      label: t(`services.${service?.toLowerCase()}`),
      serviceId: CLOUDER_SERVICES[service],
      serviceName: service,
      component: SemiMonthlySummaryDashboard,
      period,
      value: index,
      showCount: false,
    };
  });

  const handleActiveTabChange = (tab) => {
    if (tab?.serviceName) {
      setActiveTab(tab.serviceName);
    }
  };

  return {
    tabsItems: tabs,
    isLoading: isLoadingPaymentClouderServices,
    paymentClouderServices,
    handleActiveTabChange,
    activeTab,
  };
}
